// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';

import { TextField } from '../../../../atoms';
import { ErrorLabel } from '../../../../molecules/error-label';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useCurrentPaymentTypeOptionalFields } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function FieldArgentineAddress(): Node {
  const inputId = useUniqueId();
  const [value, handleChange] = useUserInputAsTextField('argentineAddress');
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('argentineAddress');
  const submitting = useSubmitting();

  const isOptionalFieldByPaymentType = useCurrentPaymentTypeOptionalFields('address');

  if (isOptionalFieldByPaymentType) {
    return null;
  }

  return (
    <div data-test-name="address-street-name">
      <label htmlFor={inputId}>Dirección</label>

      <TextField
        id={inputId}
        value={value}
        onChange={handleChange}
        fashion={formHasBeenSent && validationError ? 'error' : null}
        readOnly={submitting}
        data-error={formHasBeenSent && validationError ? 'error' : null}
        name="address-street-name"
        placeholder="Calle, Avenida o Otro"
      />

      {formHasBeenSent && validationError && (
        <ValidationMessage validationError={validationError} />
      )}
    </div>
  );
}

type ValidationMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationMessage({ validationError }: ValidationMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return (
        <ErrorLabel>
          Calle es requerido
        </ErrorLabel>
      );

    case 'server-error':
      return (
        <ErrorLabel>
          {serverErrorMessage(validationError.payload)}
        </ErrorLabel>
      );

    default:
      return (
        <ErrorLabel>
          El calle es inválido
        </ErrorLabel>
      );
  }
}
